import { createContext, useContext } from "react";
import type { DesignView } from "./design/types";

export interface DesignSelection {
  selectedDesign: DesignView | null;
  setSelectedDesign: (design: DesignView | null) => void;
}

// The selected design is local UI state (hydrated once from the campaign's
// activeRoomId on load, then user-driven) so it can be deselected/cleared
// without a server "deactivate" — mirrors the legacy behaviour.
export const DesignSelectionContext = createContext<DesignSelection>({
  selectedDesign: null,
  setSelectedDesign: () => undefined,
});

export const useDesignSelection = () => useContext(DesignSelectionContext);
